class BespokeCTA extends HTMLElement {
  constructor() {
    super();

    // Bind to buttons
    this.querySelectorAll(".js-modal-trigger").forEach((trigger) => {
      trigger.addEventListener("click", this.open.bind(this));
    });

    // Bind to close icons
    this.querySelectorAll(".js-modal-close").forEach((icon) => {
      icon.addEventListener("click", this.close.bind(this));
    });

    if (this.dataset.bespokeProduct == "true") {
      document
        .querySelector(".product-form__submit")
        .addEventListener("click", this.openProductModal.bind(this));
    }
  }

  openProductModal(event) {
    const modal = document.querySelector(".bespoke-cta__modal");
    modal.classList.add("h-screen");
    modal.classList.remove("hidden");
    this.querySelector(".js-modal-inner").classList.remove("hidden");
    this.scrollIntoView();
  }

  // Open the relevant modal
  open(event) {
    // Prevent click
    event.preventDefault ? event.preventDefault() : (event.returnValue = false);

    // Unhide the linked modal
    const found = Array.from(this.querySelectorAll(".js-modal-inner")).find(
      (item) => item.dataset.trigger === event.target.dataset.trigger
    );

    found.classList.remove("hidden");
    // Stop scroll on body
    // document.querySelector("body").classList.add("no-scroll");
    // Unhide modal container
    this.querySelector(".js-modal").classList.remove("hidden");
  }

  // Close the modals
  close(event) {
    // Prevent click
    event.preventDefault ? event.preventDefault() : (event.returnValue = false);
    // Hide all modals
    this.querySelectorAll(".js-modal-inner").forEach((modal) => {
      modal.classList.add("hidden");
    });
    // Stop scroll on body
    // document.querySelector("body").classList.remove("no-scroll");
    // Hide modal container
    this.querySelector(".js-modal").classList.add("hidden");
  }
}
customElements.define("bespoke-cta", BespokeCTA);
